module.exports = __webpack_public_path__ + "posture/static/img/high_low_shoulder_normal.d4135a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/high_low_shoulder_normal.png
// module id = v8CS
// module chunks = 1